import { ACCOUNT_MODE } from '../actions/account-mode';

export const accountModeReducers = (state = null, action) => {
  switch (action.type) {
    case ACCOUNT_MODE:
      return action.payload;
  }
  return state;
};
